import React, { useEffect, useState } from "react";
import LeadTable from "./LeadTable";
import { useOutletContext } from "react-router-dom";
import axios from "axios";
import { Autocomplete, TextField } from "@mui/material";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const INK = "#0F1B2A";
const LINE = "#E4E9EF";
const FIELD_EDGE = "#D5DEE7";
const PRIMARY = "#0B5C8A";

const LeadProjectDashboard = () => {
  const { id } = useOutletContext();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [projects, setProjects] = useState();
  const [projectId, setProjectId] = useState(
    JSON.parse(localStorage.getItem("projectId")) || id || "",
  );
  const orgId = JSON.parse(localStorage.getItem("org"));

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/project/team/all?orgId=${orgId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setProjects(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchProjects();
  }, [orgId]);

  return (
    <div style={{ fontFamily: FONT, color: INK }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: 12,
          padding: "12px 14px",
          marginBottom: 16,
          background: "#FFFFFF",
          border: `1px solid ${LINE}`,
          borderRadius: 14,
        }}
      >
        <label
          style={{
            flex: "0 0 auto",
            margin: 0,
            fontFamily: FONT,
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: "0.11em",
            textTransform: "uppercase",
            color: "#66748A",
          }}
        >
          Project
        </label>
        <Autocomplete
          className="project-selector"
          name="projectId"
          options={projects || []}
          getOptionLabel={(option) => option.projectName || ""}
          value={projects?.find((p) => p.projectId === projectId) || null}
          onChange={(e, value) => {
            setProjectId(value?.projectId || "");
            localStorage.setItem(
              "projectId",
              JSON.stringify(value?.projectId || ""),
            );
          }}
          isOptionEqualToValue={(option, value) =>
            option.projectId === value.projectId
          }
          renderInput={(params) => (
            <TextField {...params} placeholder="Select Project" />
          )}
          style={{ flex: "1 1 260px", maxWidth: 420, minWidth: 0 }}
          sx={{
            margin: 0,
            "& .MuiInputBase-root": {
              minHeight: 40,
              fontFamily: FONT,
              fontSize: "14px",
              fontWeight: 600,
              color: INK,
              borderRadius: "10px",
              padding: "1px 7px",
              background: "#FFFFFF",
            },
            "& .MuiOutlinedInput-notchedOutline": { borderColor: FIELD_EDGE },
            "& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#B4C6DA" },
            "& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: PRIMARY,
              borderWidth: 1,
            },
            "& .MuiInputBase-input::placeholder": { color: "#8A97A8", fontWeight: 500, opacity: 1 },
          }}
          slotProps={{
            paper: {
              sx: {
                mt: 0.5,
                borderRadius: "12px",
                border: `1px solid ${LINE}`,
                boxShadow: "0 16px 36px -12px rgba(15,27,42,0.24)",
                "& .MuiAutocomplete-option": {
                  fontFamily: FONT,
                  fontSize: 13.5,
                  borderRadius: "8px",
                  mx: 0.75,
                },
                "& .MuiAutocomplete-option[aria-selected='true']": {
                  background: "#EAF2FB !important",
                  color: "#1B4F82",
                  fontWeight: 700,
                },
              },
            },
          }}
        />
      </div>
      <LeadTable projectId={projectId} />
    </div>
  );
};

export default LeadProjectDashboard;
